import axios from 'axios';
import { uiMessage } from './uiText';

function result(response) {
    if (response.data.code !== 200) throw new Error(response.data.msg || "Server processing failed.");
    const data = response.data.data;
    if (!data?.originalSaved || !['PARSED', 'CONFIRMED'].includes(data.status) || !data.bundle) {
        const error = new Error(data?.message || "The file was not stored or parsed successfully. Please retry.");
        error.issues = data?.issues || []; error.originalSaved = !!data?.originalSaved; throw error;
    }
    return data;
}
const headers = () => ({ Authorization: localStorage.getItem('userInfo') || '' });
export async function uploadNetwork(file, network, signal) {
    const form = new FormData(); form.append('file', file); form.append('gene', network.gene);
    if (network.datasetVersion) form.append('datasetVersion', network.datasetVersion);
    if (network.unitId) form.append('unitId', network.unitId);
    try { return result(await axios.post('/api/rgnet/uploads', form, { headers: headers(), signal, timeout: 60000 })); }
    catch (error) { error.message = uiMessage(error.response?.data?.msg || error.message, "Upload failed or its storage result was not received. Please retry."); throw error; }
}
export async function confirmNetworkUpload(id, build, signal) {
    try { return result(await axios.post(`/api/rgnet/uploads/${encodeURIComponent(id)}/confirm`, { genomeBuild: build, confirmed: true }, { headers: headers(), signal, timeout: 30000 })); }
    catch (error) { error.message = uiMessage(error.response?.data?.msg || error.message, "Could not save the confirmation. The current network is unchanged; please retry."); throw error; }
}
